export const useRegionSwitcherRedesign =
  process.env.GATSBY_SHOW_REGION_SWITCHER_REDESIGN === 'true'

let params
if (typeof document !== 'undefined') {
  params = new URLSearchParams(document.location.search)
}
export const useContentfulNav =
  process.env.GATSBY_USE_CONTENTFUL_NAV === 'true' ||
  params?.get('useContentfulNav') === 'true'
